import {compactKpiDescription} from "../../../performance/Kpi";
import React from "react";
import styled from "styled-components";
import CompactPerformanceValue from "../../../performance/CompactPerformanceValue";
import {asLocalTime} from "../../../../util/timeDescription";
import {useSelector} from "react-redux";
import {Clock} from "js-joda";

const AuthorKpiContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: flex-end;
    padding-left: 18px;
`;

const KpiDetails = styled.div`
    max-width: 400px;
    text-align: right;
`;

const AuthorKpiValue = styled.div`
    font-size: 26px;
    font-weight: bold;
`;


const KpiTime = styled.div`
    color: #948D87;
    font-size: 10px;
    text-align: right;
    margin-top: 0;
`;

export const AuthorKpiHeading = ({portfolioAuthor}) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());

    if (!portfolioAuthor.kpi) {
        return <AuthorKpiContainer className="t-header"/>
    }

    return (
        <AuthorKpiContainer className="t-header">
            <KpiDetails className="t-kpi">
                <div>{compactKpiDescription(portfolioAuthor.kpi, portfolioAuthor.benchmarkSource, portfolioAuthor.defaultBenchmark)}</div>
            </KpiDetails>
            <AuthorKpiValue className="t-kpi-value">
                <CompactPerformanceValue kpi={portfolioAuthor.kpi} value={portfolioAuthor.kpiValue} currency={portfolioAuthor.performanceSettings.currency}/>
            </AuthorKpiValue>
            <KpiTime className="t-kpi-timestamp">as at {asLocalTime(portfolioAuthor.generatedAt, clock)}</KpiTime>
        </AuthorKpiContainer>
    );
};
